export default "__VITE_ASSET__D31r7AnW__"